import type { SimpleKeyboard } from 'react-simple-keyboard';

import { getWritableInputTypesConfig } from '../utils/KeyUtils';
import { KeyboardModule, KeyboardOptionsExt } from 'components/Keyboard/types';
import { SPECIAL_KEYS } from '../utils/constants';
import { syncShiftTheme } from './shiftLock';

// Sentence-case behavior for general text inputs: the keyboard opens on the 'shift' (uppercase)
// layout while the field is empty, then releases to 'default' once a character exists, and re-arms
// when the field is emptied again — so only the first letter is auto-capitalized. Manual SHIFT
// presses are left to shiftLock (we skip re-evaluation on them). Registered after multiKeyboards so
// its baseline reset is already applied, and after shiftLock so SHIFT toggling still composes.
function sentenceCase(keyboard: SimpleKeyboard) {
  keyboard.registerModule('sentenceCase', (module: KeyboardModule) => {
    const { language, type } = keyboard.getOptions() as KeyboardOptionsExt;
    if (getWritableInputTypesConfig(language)[type]?.casing !== 'sentence') {
      return;
    }

    const applyLayout = () => {
      keyboard.setOptions({ layoutName: keyboard.getInput() ? 'default' : 'shift' });
      syncShiftTheme(keyboard);
    };

    module.fn = { handleButtonClicked: keyboard.handleButtonClicked };
    applyLayout();

    keyboard.handleButtonClicked = (...args) => {
      const [button] = args;
      module.fn.handleButtonClicked.call(keyboard, ...args);
      if (button !== SPECIAL_KEYS.SHIFT) {
        applyLayout();
      }
    };
  });
}

export default sentenceCase;
